// Direct file import, not the `./types` barrel: this enum is read at module top level below, and the
// barrel pulls the whole module graph in - a cycle then leaves the enum undefined at that read. This
// file is now reached from the large-document model, which is imported by the save path.
import { EHeadingsSelectionMode } from './types/dialogs.types';

export const DOTS_POSITIONS = [
  '-top-1.5 -left-1.5 cursor-nwse-resize',
  '-bottom-1.5 -left-1.5 cursor-nesw-resize',
  '-top-1.5 -right-1.5 cursor-nesw-resize',
  '-bottom-1.5 -right-1.5 cursor-nwse-resize',
];

export const DOCUMENT_HTML_ATTRIBUTES = Object.freeze({
  DEFAULT_ID: 'id',
  /**
   * Used by the `CustomUniqueId` extension
   * and in `Changes` component.
   */
  CUSTOM_UNIQUE_ID: 'data-id',
  /** Which stored value a template field shows. */
  TEMPLATE_FIELD_ID: 'data-field-id',
});

export const SELECT_HEADING_DIALOG_OPTIONS = [
  {
    value: EHeadingsSelectionMode.ALL,
    title: 'All',
    subtitle: 'Entire document',
    tooltip: 'Select all sections in the document.',
  },
  {
    value: EHeadingsSelectionMode.SPECIFIC,
    title: 'Specific',
    subtitle: 'Specific sections',
    tooltip: 'Select specific sections in the document.',
  },
];

export const SELECT_HEADING_DIALOG_MODE_LOCKED_MESSAGE = {
  SELF_REF: 'You cannot reference the entire document to itself.',
  NO_HEADINGS: 'There are no sections in the document to select.',
};

export const SECTION_AUTO_SELECTED_TOOLTIP =
  'This section is auto-selected because you have selected a parent section.';

export const DEFAULT_DOCUMENT_CONTENT = 'Loading...';

// Bound an explicit save's wait without aborting uploads or allowing unfinished content to be saved.
export const EDITOR_OPERATION_WAIT_TIMEOUT_MS = 30_000;

export const EDITOR_OPERATION_FAILED_MESSAGE = 'Something went wrong. Please reload the page.';

export const COMPLETE_WHILE_CONNECTING_FAILED_MESSAGE = 'Completing version failed, as the editor is still connecting.';
